import { RoleBasedGuard } from ".";
import { useAuthContext } from "../hooks"

export const AdminGuard = ({ children }) => {
  const { user: { Role: role } } = useAuthContext();

  return (
    <RoleBasedGuard acceptRoles={["Owner", "Admin"]} currentRole={role} hasContent>
      {children}
    </RoleBasedGuard>
  )
}